import { useSyncExternalStore } from 'react';

/**
 * Wide enough for the drawn views (768px and up): the process tree arranged by
 * hand, the design board's canvas, the funnel across. Below it they are
 * recomposed for a phone (a list, a stack, the funnel down), never shrunk.
 */
export function useWide(): boolean {
  return useSyncExternalStore(
    (on) => {
      const q = window.matchMedia('(min-width: 768px)');
      q.addEventListener('change', on);
      return () => q.removeEventListener('change', on);
    },
    () => window.matchMedia('(min-width: 768px)').matches,
    () => true,
  );
}
